import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { DocFeedbackStatusDB } from '../../../../../api/types/docs/doc-feedback-status';
import { DocDetails } from '../../../../../api/types/docs/doc-details';

export const updateDocFeedbackHomescreenOperation = async (
  userId: number,
  user: UserSummaryType,
  dockId: number,
  feedbackId: number,
  status: DocFeedbackStatusDB,
  setDocs: (docs: DocDetails[]) => any,
  onUpdate: () => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.updateDocFeedback(
      userId,
      dockId,
      feedbackId,
      status,
    );
    setLoading(false);
    onUpdate();
    toast.info('עדכון הסטטוס בוצע בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
